<template>
  <v-card :loading="loading.card">
    <v-form v-model="isQuantityValid" ref="quantityForm">
      <v-card-title>
        <v-row align="center">
          <v-col cols="11">
            <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.customDistribution') }} ({{ shipmentDetail.description }})</span>
          </v-col>
          <v-spacer>
          </v-spacer>
          <v-col>
            <v-btn :disabled="loading.card" icon @click.stop="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-toolbar-title>{{ $t('label.remaining') }}: {{ remaining }}</v-toolbar-title>
          </v-col>
          <!-- <v-spacer>
          </v-spacer> -->
          <v-col cols="2">
            <v-checkbox
              v-model="isPackage"
              :label="$t('label.package')"
              :disabled="remaining === 0"
              >
            </v-checkbox>
          </v-col>
          <v-col cols="3">
              <v-text-field
                  ref="inputQuantity"
                  :label="isPackage ? $t('label.packageDivisor') : $t('label.quantity')"
                  :type="isPackage ? 'number' : 'text'"
                  v-model="quantity"
                  dense
                  @focus="$event.target.select()"
                  :rules="isPackage ? [rules.positiveInteger] : [rules.number, rules.maxValue(quantity, remaining), rules.minValue(quantity, 0)]"
                  :disabled="remaining === 0"
                  >
              </v-text-field>
          </v-col>
          <v-col cols="1">
              <v-btn
                  type="submit"
                  class="mr-3"
                  color="primary"
                  @click="addItem"
                  :disabled="!isQuantityValid || remaining === 0"
                  small
                  >
                  {{ $t('label.add') }}
              </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
    </v-form>
    <v-card-text style="height: 400px;">
        <v-data-table
            :items="items"
            item-key="id"
            :headers="headers"
            disable-pagination
            hide-default-footer
            >
            <template v-slot:[`item.options`]="{ item }">
                <v-btn class="btn-action" icon :title="$t('label.delete')" small depressed @click.stop="deleteItem(item)">
                    <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer>
      </v-spacer>
      <v-btn
        small
        depressed
        color="primary"
        :disabled="!canPrintAndSave"
        @click.stop="printCustom"
        >
        {{ $t('label.saveAndPrint') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { showMessage, rules } from '../../../mixins'
import { v4 as uuidv4 } from 'uuid'
import { saveAs } from 'file-saver'
export default {
  name: 'CustomDistribution',
  mixins: [showMessage, rules],
  props: {
    shipmentDetailId: {
      type: Number
    }
  },
  data: () => ({
    shipmentDetail: {
      partNumber: '',
      description: '',
      quantityToShip: 0,
      shipmentStatus: 1
    },
    loading: {
      card: false
    },
    items: [],
    quantity: '',
    isQuantityValid: null,
    isPackage: false
  }),
  computed: {
    headers () {
      const headers = [
        { text: this.$t('label.quantity'), value: 'quantity', align: 'center', sortable: true, filterable: false },
        { text: this.$t('label.options'), value: 'options', align: 'center', sortable: false, filterable: false }
      ]
      return headers
    },
    remaining () {
      const summatory = this.items.reduce((acc, item) => acc + parseFloat(item.quantity), 0)
      var r = Math.round((parseFloat(this.shipmentDetail.quantityToShip) - parseFloat(summatory)) * 1000) / 1000
      if (r < 0) {
        r = 0
      }
      return r
    },
    canPrintAndSave () {
      return this.remaining === 0.000 && this.shipmentDetail.shipmentStatus !== 2
    }
  },
  methods: {
    async printCustom () {
      try {
        this.loading.card = true
        const response = await this.$proxy.post(`api/shipments/custom-print/${this.shipmentDetailId}`, { items: this.items }, 'blob')
        saveAs(response.data, `ShipmentDetail-${this.shipmentDetailId}.pdf`)
        this.close()
      } catch (error) {
        this.showHttpErrorMessage(error)
      } finally {
        this.loading.card = false
      }
    },
    async getCustomDistributions () {
      try {
        this.loading.card = true
        const response = await this.$proxy.get(`api/shipments/custom-print/${this.shipmentDetailId}`)
        this.items = response.data
      } catch (error) {
        this.showHttpErrorMessage(error)
      } finally {
        this.loading.card = false
      }
    },
    deleteItem (selectedItem) {
      this.items = this.items.filter(item => item.id !== selectedItem.id)
    },
    addItem (event) {
      event.preventDefault()
      if (this.isPackage) {
        // Aritmética en milésimas enteras: Math.trunc con flotantes recortaba 15.422 a 15.421
        const totalMils = Math.round(parseFloat(this.shipmentDetail.quantityToShip) * 1000)
        const packages = parseInt(this.quantity, 10)
        const baseMils = Math.round(totalMils / packages)
        this.items = []
        for (let index = 0; index < packages; index++) {
          const item = { quantity: parseFloat((baseMils / 1000).toFixed(3)), id: uuidv4() }
          this.items.push(item)
        }
        const diffMils = totalMils - (baseMils * packages)
        if (diffMils !== 0) {
          const last = this.items[this.items.length - 1]
          last.quantity = parseFloat(((baseMils + diffMils) / 1000).toFixed(3))
        }
        return
      }

      var re = new RegExp('^-?\\d+(?:.\\d{0,' + (3 || -1) + '})?')
      this.quantity = this.quantity.toString().match(re)[0]
      const item = { quantity: parseFloat(this.quantity), id: uuidv4() }
      this.items = [item, ...this.items]
      this.$refs.quantityForm.reset()
      this.$refs.inputQuantity.focus()
    },
    async getShipmentDetail () {
      try {
        this.loading.card = true
        const response = await this.$proxy.get(`api/shipments/detail/${this.shipmentDetailId}`)
        this.shipmentDetail = response.data
      } catch (error) {
        this.showHttpErrorMessage(error)
      } finally {
        this.loading.card = false
      }
    },
    close () {
      this.$emit('close')
    }
  },
  watch: {
    shipmentDetailId: {
      handler () {
        if (this.$refs.quantityForm) {
          this.$refs.quantityForm.reset()
        }
        this.getShipmentDetail()
        this.getCustomDistributions()
      },
      immediate: true
    }
  }
}
</script>

<style>

</style>
